import {
  Box,
  Button,
  Card,
  Divider,
  FormControl,
  IconButton,
  InputLabel,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Radio,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import "./roles-permissions.css";
import { useEffect, useState } from "react";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { permissionAccessLevels, userType } from "../../../utils/Constant";
import AddIcon from "@mui/icons-material/Add";
import AddRole from "./add-role/add-role";
import EditRole from "./edit-role/edit-role";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import {
  permissionRequest,
  roleDetailsRequest,
  roleDetailsSuccess,
  roleRequest,
  roleSuccess,
} from "../../../redux/roles/slice";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../components/loading/loading";
import DeleteRoleAlertDialog from "./delete-role-alert-dialog/delete-role-alert-dialog";
import {
  assignPermission,
  deleteRole,
  duplicateRole,
} from "../../../utils/APICalls";
import DeleteRoleErrorDialog from "./delete-role-error-dialog/delete-role-error-dialog";
import ContactSpectrum from "../../../components/contact-spectrum/constact-spectrum";
import Notification from "../../../components/notification/notification";

const Menus = ({ onDeleteClick, onEditClick, onDuplicateClick }: any) => {
  return (
    <>
      <MenuItem
        onClick={(event) => {
          event.stopPropagation();
          onEditClick();
        }}
      >
        <ListItemIcon>
          <EditOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary="Edit Role Name" />
      </MenuItem>
      <MenuItem
        onClick={(event) => {
          event.stopPropagation();
          onDuplicateClick();
        }}
      >
        <ListItemIcon>
          <ContentCopyOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary="Duplicate Role" />
      </MenuItem>
      <Divider />
      <MenuItem
        onClick={(event) => {
          event.stopPropagation();
          onDeleteClick();
        }}
      >
        <ListItemIcon>
          <DeleteOutlineOutlinedIcon color="error" />
        </ListItemIcon>
        <ListItemText sx={{ color: "#d32f2f" }} primary="Delete Role" />
      </MenuItem>
    </>
  );
};

export default function RolesPermission() {
  const [hoveredIndex, setHoveredIndex] = useState(-1);
  const [showListItemMenu, setShowListItemMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [categoryNames, setCategoryNames] = useState<string[]>([]);
  const [showAddRole, setShowAddRole] = useState(false);
  const [showEditRole, setShowEditRole] = useState(false);
  const [roleType, setRoleType] = useState("Internal");
  const [selectedRoleData, setSelectedRoleData] = useState<any>(null);
  const [allPermissions, setAllPermissions] = useState([]);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showDeleteErrorDialog, setShowDeleteErrorDialog] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [editRoleFromSelected, setEditRoleFromSelected] = useState(false);
  const [addRole, setAddRole] = useState("");
  const [showRoleCreatedAlert, setShowRoleCreatedAlert] = useState(false);

  const { allRoles: roleResponse } = useSelector((state: any) => state.roles);
  const { allPermissions: allPermissionsResponse } = useSelector(
    (state: any) => state.roles
  );
  const { roleDetails: roleDetailsResponse } = useSelector(
    (state: any) => state.roles
  );
  const { loading } = useSelector((state: any) => state.roles);
  const dispatch = useDispatch();

  const open = Boolean(anchorEl);

  useEffect(() => {
    dispatch(roleDetailsSuccess({ response: null }));
    dispatch(roleSuccess({ response: null }));
  }, []);// eslint-disable-line

  useEffect(() => {
    let type;
    if (roleType === "Internal") {
      type = userType.tenant;
    }
    if (roleType === "Client") {
      type = userType.client;
    }
    if (roleType === "Inspection Firm") {
      type = userType.inspector;
    }
    dispatch(roleRequest(type));
    dispatch(permissionRequest(type));
    setSelectedRoleData(null);
  }, [roleType]); // eslint-disable-line

  useEffect(() => {
    if (
      roleResponse &&
      roleResponse.length > 0 &&
      allPermissionsResponse &&
      allPermissionsResponse.length > 0
    ) {
      if (addRole) {
        const roleIndex = roleResponse.findIndex(
          (role: any) => role.id === addRole
        );
        const selectedRole = roleResponse[roleIndex];
        setSelectedRoleData(selectedRole);
        mapPermissions(selectedRole);
        dispatch(roleDetailsRequest(selectedRole?.id));
        setAddRole("");
        return;
      }
      initializePermission(allPermissionsResponse);
      const selectedRole = roleResponse[0];
      setSelectedRoleData(selectedRole);
      dispatch(roleDetailsRequest(selectedRole?.id));
    }
  }, [roleResponse, allPermissionsResponse]); // eslint-disable-line

  useEffect(() => {
    if (roleDetailsResponse) {
      setSelectedRoleData(roleDetailsResponse);
      mapPermissions(roleDetailsResponse);
    }
  }, [roleDetailsResponse]); // eslint-disable-line

  const initializePermission = (allPermissions: any[]) => {
    const permissions = JSON.parse(JSON.stringify(allPermissions));
    permissions.forEach((permission: any) => {
      permission.accessLevel = permissionAccessLevels.noAccess;
    });
    setAllPermissions(permissions);

    // Categorizing all permissions
    const categoryNames: string[] = [];
    permissions.forEach((permission: any) => {
      if (!categoryNames.includes(permission.category.name)) {
        categoryNames.push(permission.category.name);
      }
    });
    setCategoryNames(categoryNames);
  };

  const mapPermissions = (roleDetails: any) => {
    //Map role permission to permission list
    const permissions = [...allPermissions];
    permissions.forEach((permission: any) => {
      permission.accessLevel = permissionAccessLevels.noAccess;
      roleDetails?.permissions.forEach((rolePermission: any) => {
        if (permission.id === rolePermission.resourceId) {
          permission.accessLevel = rolePermission.accessLevel;
        }
      });
    });
    setAllPermissions(permissions);
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number
  ) => {
    const selectedRole = roleResponse[index];
    setSelectedRoleData(selectedRole);

    dispatch(roleDetailsRequest(selectedRole?.id));

    //Map role permission to permission list
    const permissions = [...allPermissions];
    permissions.forEach((permission: any) => {
      permission.accessLevel = permissionAccessLevels.noAccess;
      selectedRole?.permissions.forEach((rolePermission: any) => {
        if (permission.id === rolePermission.resourceId) {
          permission.accessLevel = rolePermission.accessLevel;
        }
      });
    });
    setAllPermissions(permissions);
  };

  const handleListItemHover = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number
  ) => {
    setHoveredIndex(index);
    setShowListItemMenu(true);
    setAnchorEl(null);
  };

  const handleMenuClose = (event: any) => {
    event.stopPropagation();
    setAnchorEl(null);
    setShowListItemMenu(false);
  };

  const onSaveRole = () => {
    setSelectedRoleData(null);
  };

  const onDeleteRole = () => {
    setShowDeleteDialog(true);
  };

  const roleTypeChange = (e: SelectChangeEvent) => {
    setRoleType(e.target.value);
  };

  const onEditRole = () => {
    setEditRoleFromSelected(false);
    setShowEditRole(true);
  };

  const onDuplicateRole = () => {
    duplicateRoleName();
  };

  const onAddRole = (roleId: string) => {
    setAddRole(roleId);
  };

  const onChangePermission = async (
    event: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    const permissions = JSON.parse(JSON.stringify(allPermissions));
    const data: any = {
      id: selectedRoleData?.id,
      resourceId: id,
    };
    const permissionIndex = permissions.findIndex(
      (permission: any) => permission.id === id
    );
    if (event.target.value === "full-access") {
      permissions[permissionIndex].accessLevel =
        permissionAccessLevels.fullAccess;
      data.accessLevel = "FullAccess";
    } else if (event.target.value === "view-only") {
      permissions[permissionIndex].accessLevel =
        permissionAccessLevels.viewOnly;
      data.accessLevel = "ViewOnly";
    } else {
      permissions[permissionIndex].accessLevel =
        permissionAccessLevels.noAccess;
      data.accessLevel = "NoAccess";
    }
    setAllPermissions(permissions);

    setShowLoader(true);
    await assignPermission(data);
    setShowLoader(false);
  };

  const deleteRoleName = async () => {
    const roleId = roleResponse[hoveredIndex]?.id;
    setShowDeleteDialog(false);
    setShowLoader(true);
    const response = await deleteRole(roleId);
    setShowLoader(false);
    if (response?.status === 204) {
      if (roleType === "Internal") {
        dispatch(roleRequest(userType.tenant));
      } else if (roleType === "Client") {
        dispatch(roleRequest(userType.client));
      } else if (roleType === "Inspection Firm") {
        dispatch(roleRequest(userType.inspector));
      }
      setSelectedRoleData(null);
    } else if (response?.status === 409) {
      setShowDeleteErrorDialog(true);
    }
  };

  const duplicateRoleName = async () => {
    const roleId = roleResponse[hoveredIndex]?.id;
    setShowLoader(true);
    const response = await duplicateRole(roleId);
    setShowLoader(false);
    if (response?.status === 201) {
      setAddRole(`Copy of ${roleResponse[hoveredIndex]?.name}`);
      if (roleType === "Internal") {
        dispatch(roleRequest(userType.tenant));
      } else if (roleType === "Client") {
        dispatch(roleRequest(userType.client));
      } else if (roleType === "Inspection Firm") {
        dispatch(roleRequest(userType.inspector));
      }
      setSelectedRoleData(null);
    }
  };

  return (
    <>
      <ContactSpectrum />
      <Breadcrumb />
      <Typography sx={{ ml: 2 }} className="title">
        Roles & Permissions
      </Typography>
      <Box className="roles-division-container">
        <Box className="roles-select-division">
          <FormControl fullWidth sx={{ mt: 1 }}>
            <InputLabel id="demo-simple-select-label">Role Type</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Role Type"
              onChange={roleTypeChange}
              value={roleType}
            >
              <MenuItem value="Internal">Internal Roles</MenuItem>
              <MenuItem value="Client">Client Roles</MenuItem>
              <MenuItem value="Inspection Firm">Inspection Firm Roles</MenuItem>
            </Select>
          </FormControl>
          <Box className="coordinator-division-list-layout">
            <List component="nav" aria-label="sub division">
              {roleResponse?.map((item: any, index: number) => (
                <ListItemButton
                  key={index}
                  selected={selectedRoleData?.id === item.id}
                  onClick={(event) => handleListItemClick(event, index)}
                  onMouseEnter={(event) => handleListItemHover(event, index)}
                  onMouseLeave={() => setShowListItemMenu(false)}
                  sx={{
                    "&:hover": {
                      padding: "8px",
                    },
                    padding: "8px",
                  }}
                >
                  <ListItemText sx={{ marginTop: "8px" }} primary={item.name} />
                  {showListItemMenu && hoveredIndex === index && (
                    <Box>
                      <IconButton
                        onClick={handleMenuClick}
                        aria-label="more"
                        aria-controls="role-menu"
                        aria-haspopup="true"
                      >
                        <MoreHorizIcon color="primary" />
                      </IconButton>
                      <Menu
                        sx={{
                          ".MuiMenu-list": { padding: 0 },
                          ".MuiDivider-root": { margin: "0px !important" },
                        }}
                        id="role-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleMenuClose}
                        slotProps={{
                          paper: { style: { width: 250 } },
                        }}
                      >
                        <Menus
                          onDeleteClick={onDeleteRole}
                          onEditClick={onEditRole}
                          onDuplicateClick={onDuplicateRole}
                        />
                      </Menu>
                    </Box>
                  )}
                </ListItemButton>
              ))}
            </List>
          </Box>
          <Button
            color="primary"
            startIcon={<AddIcon color="primary" />}
            onClick={() => setShowAddRole(true)}
          >
            Add Roles
          </Button>
        </Box>
        <Box className="role-division-details">
          {selectedRoleData && (
            <Card className="card-layout">
              <Box className="cards-header">
                <Typography variant="h5">{selectedRoleData.name}</Typography>
                <Button
                  sx={{ ml: 3 }}
                  variant="text"
                  startIcon={<EditOutlinedIcon />}
                  onClick={() => {
                    setEditRoleFromSelected(true);
                    setShowEditRole(true);
                  }}
                >
                  Edit
                </Button>
              </Box>
              <Box sx={{ mt: 3, px: 1.5 }}>
                <Box
                  sx={{
                    width: "calc(100% - 192px)",
                    marginLeft: 24,
                    display: "flex",
                  }}
                >
                  <Typography
                    sx={{ flex: 1, textAlign: "start", fontWeight: "bold" }}
                  >
                    Permission
                  </Typography>
                  <Typography
                    sx={{ flex: 1, textAlign: "center", fontWeight: "bold" }}
                  >
                    Full Access
                  </Typography>
                  <Typography
                    sx={{ flex: 1, textAlign: "center", fontWeight: "bold" }}
                  >
                    View Only
                  </Typography>
                  <Typography
                    sx={{ flex: 1, textAlign: "center", fontWeight: "bold" }}
                  >
                    None
                  </Typography>
                </Box>
                {categoryNames?.map((categoryName: any, index: number) => {
                  const permissions = allPermissions?.filter(
                    (permission: any) =>
                      permission.category.name === categoryName
                  );
                  return (
                    <Box key={categoryName}>
                      {index > 0 && <Divider />}
                      <Box className="user-name-layout">
                        <Typography className="label-txt" sx={{ mt: 2 }}>
                          {categoryName}
                        </Typography>
                        <Box
                          display={"block"}
                          sx={{ width: "calc(100% - 192px)" }}
                        >
                          {permissions?.map((item: any, index: number) => (
                            <Box key={item.key}>
                              <Box className="permissions-row">
                                <Box className="permissions-title">
                                  <Typography>{item.name}</Typography>
                                </Box>
                                <Radio
                                  className="permissions-radio"
                                  value="full-access"
                                  name="radio-buttons"
                                  inputProps={{ "aria-label": "A" }}
                                  checked={
                                    item.accessLevel ===
                                    permissionAccessLevels.fullAccess
                                  }
                                  onChange={(e) =>
                                    onChangePermission(e, item.id)
                                  }
                                />
                                <Radio
                                  className="permissions-radio"
                                  value="view-only"
                                  name="radio-buttons"
                                  inputProps={{ "aria-label": "B" }}
                                  checked={
                                    item.accessLevel ===
                                    permissionAccessLevels.viewOnly
                                  }
                                  onChange={(e) =>
                                    onChangePermission(e, item.id)
                                  }
                                />
                                <Radio
                                  className="permissions-radio"
                                  value="none"
                                  name="radio-buttons"
                                  inputProps={{ "aria-label": "C" }}
                                  checked={
                                    item.accessLevel ===
                                    permissionAccessLevels.noAccess
                                  }
                                  onChange={(e) =>
                                    onChangePermission(e, item.id)
                                  }
                                />
                              </Box>
                              {index !== permissions.length - 1 && <Divider />}
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Card>
          )}
        </Box>
      </Box>
      {roleResponse && hoveredIndex >= 0 && (
        <EditRole
          showDialog={showEditRole}
          roleType={roleType}
          closeDialog={() => setShowEditRole(false)}
          data={
            editRoleFromSelected ? selectedRoleData : roleResponse[hoveredIndex]
          }
          onSave={onSaveRole}
        />
      )}
      {showAddRole && (
        <AddRole
          roleType={roleType}
          showDialog={showAddRole}
          closeDialog={() => setShowAddRole(false)}
          onAddRole={onAddRole}
          setShowRoleCreatedAlert={setShowRoleCreatedAlert}
        />
      )}
      <DeleteRoleAlertDialog
        showDialog={showDeleteDialog}
        closeDialog={() => setShowDeleteDialog(false)}
        onDelete={deleteRoleName}
      />
      <DeleteRoleErrorDialog
        showDialog={showDeleteErrorDialog}
        closeDialog={() => setShowDeleteErrorDialog(false)}
      />
      {(loading || showLoader) && <Loading />}
      <Notification
        show={showRoleCreatedAlert}
        title="Role is created successfully"
        onClose={() => setShowRoleCreatedAlert(false)}
      />
    </>
  );
}
